import script from "./Rate.vue?vue&type=script&setup=true&lang=js"
export * from "./Rate.vue?vue&type=script&setup=true&lang=js"

import "./Rate.vue?vue&type=style&index=0&id=76304c58&lang=css"

const __exports__ = script;

export default __exports__